import $ from 'jquery';
import { Form } from './form';
import analytics from './analytics';

const JS_CLASS = 'js-form-mailing-list';

class FormMailingList extends Form {
  // Override default onSubmit method of Form
  onSubmit(e) {
    const self = this;

    e.preventDefault();

    $.ajax({
      url: this.dom.$form.attr('action'),
      method: 'POST',
      data: this.dom.$form.serialize(),
      success: (res) => {
        self.dom.$resultText.text(res.text);
        self.dom.$content.removeClass('is-shown');
        self.dom.$result.addClass('is-shown');

        analytics.push({
          event: 'unicefFormSubmitted',
          formName: `${self.name} - ${self.getFieldValue('list_name')}`
        });
      }
    });
  }

  onInit() {
    this.dom.$content = this.dom.$form.find(`.${JS_CLASS}__content`);
    this.dom.$result = this.dom.$form.find(`.${JS_CLASS}__result`);
    this.dom.$resultText = this.dom.$form.find(`.${JS_CLASS}__result-text`);
    this.dom.$showDescriptionBtn = this.dom.$form.find(`.${JS_CLASS}__show-description`);
    this.dom.$description = this.dom.$form.find(`.${JS_CLASS}__description`);

    this.dom.$showDescriptionBtn.on('click', () => {
      this.dom.$description.addClass('is-shown');
      this.dom.$showDescriptionBtn.remove();
    });

    this.name = this.dom.$form.data('form-name');
  }
}


export default {
  initForms: () => {
    $('.' + JS_CLASS).each(function () {
      const $form = $(this);

      if($form.data('form-name') === 'mailing-list') {
        const form = new FormMailingList(this);
        form.init();
      }
    });
  }
}
